export interface ObjectResponse {
  '@type': string;
  '@id': string;
}

export function isObjectResponse(object: unknown): object is ObjectResponse {
  return Object.prototype.hasOwnProperty.call(object, '@type');
}
